import styled, { keyframes, css } from "styled-components";

const flash = (props) => keyframes`
  from {
    background-color: ${props.flashColor || "orange"};
  }
  to: {
    background-color: inherit;
  }
`;

export const Table = styled.table`
  width: 100%;
  table-layout: ${(props) => (props.fixed ? "fixed" : "auto")};
  font-size: ${(props) => (props.fontSize ? props.fontSize : "inherit")};
  margin-bottom: ${(props) => (props.marginBottom ? props.marginBottom : "0")};
  margin-top: ${(props) => (props.marginTop ? props.marginTop : "0")};
  border: 1px solid ${(props) => props.theme.table.border};
  & > tbody {
    display: ${(props) => (props.fixed ? "block" : "table-row-group")};
  }

  > thead > tr {
    display: ${(props) => (props.fixed ? "block" : "table-row")};
    position: ${(props) => (props.fixed ? "relative" : "static")};
    padding-right: 1rem;
    background-color: ${(props) => props.theme.table.header};
    border-bottom: 0;
  }
`;

const animationRule = css`
  ${flash} 3s;
`;

export const TableRow = styled.tr`
  width: 100%;
  border: 1px solid ${(props) => props.theme.table.border};
  background-color: ${(props) =>
    props.selected ? props.theme.table.selectedRow : props.theme.table.row};
  > td,
  th {
    padding: 0.1rem;
    text-align: left;
  }

  animation: ${(props) => (props.flash ? animationRule : "none")};
`;

export const TableBody = styled.tbody`
  overflow: auto;
  overflow-y: ${(props) => (props.overflowY ? props.overflowY : "auto")};
  height: ${(props) => (props.height ? props.height : "auto")};
  width: 100%;
`;

export const TableCell = styled.td`
  padding: 0.0625rem 0.2rem !important;
  vertical-align: top;
  width: ${(props) => (props.width ? props.width : "auto")};
  border: 1px solid ${(props) => props.theme.table.border};
`;

export const TableRemoveCell = styled(TableCell)`
  font-weight: normal;
  text-align: center !important;
  width: 1.25rem;

  &:hover {
    cursor: ${(props) => (props.clickable ? "pointer" : "default")};
  }
`;

export const TableHeader = styled.thead`
  background-color: ${(props) => props.theme.table.header};
  border: 1px solid ${(props) => props.theme.table.border};
  font-weight: ${(props) => (props.bold ? "bold" : "normal")};
`;

export const TableHeaderCell = styled.th`
  width: ${(props) => (props.width ? props.width : "auto")};
`;

export const CellContent = styled.div`
  white-space: normal;
`;



// WEBPACK FOOTER //
// ./app/styled-components/Table.js